import { Link } from '@tanstack/react-router';
import { Button } from './Button.js';

export function NotFound() {
  return (
    <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-12">
      <h1 className="text-2xl font-semibold sm:text-3xl">Page not found</h1>
      <p className="mt-4 text-sm">The page you are looking for could not be found.</p>
      <div className="mt-6">
        <Button asChild>
          <Link to="/planner/type" data-name="not-found-home">
            Return to planner
          </Link>
        </Button>
      </div>
    </main>
  );
}
